import { config } from '@/utils/config';
import { Toast } from 'react-vant';
// import { login } from '@/utils/reLogin';
import { history } from '@umijs/max';
import type { RequestConfig } from '@umijs/max';

export const NoLoginCode = [600, 601, 602, 401];
console.log(44444444, config.token);
// 与后端约定的响应数据格式
interface ResponseStructure {
  code?: number;
  msg?: string;
  data?: any;
}
export const errorConfig: RequestConfig = {
  timeout: 10_000,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem('token') || ''}`,
    'Company-agent': 'community_weinan', // community_default
    // 'Company-agent': 'community_default',
    'Product': 'PUB_MOBILE', // 区分移动端业主端
    'openId': window.localStorage.getItem('openId') || ''
  },
  // baseURL:
  //   process.env.NODE_ENV !== 'production' ? config.devPrefix : config.proPrefix,

  errorConfig: {
    errorThrower: (res: ResponseStructure) => {
      const { code, msg, data } = res;
      if (data?.code !== 200) {
        const error: any = new Error(msg);
        error.name = 'property_error';
        error.info = { data, code, msg };
        console.log(res, 'error res');
        throw error;
      }
    },

    errorHandler: (error: any, opt: any) => {
      if (opt?.skipErrorHandler) throw error;
      if (error.name === 'property_error') {
        const errorInfo: ResponseStructure | undefined = error.info;
        if (errorInfo) {
          const { data } = errorInfo;
          console.log(errorInfo, 'errorInfo');
          switch (
            data.status
            // TODO:
          ) {
          }
        }
      }
    },
  },
  // 请求拦截器
  requestInterceptors: [
    (config: any) => {
      // 拦截请求配置，进行个性化处理。
      // const url = config.url.concat('?token = 123');
      // return { ...config, url };
      if (window.localStorage.getItem('token')) {
        config.headers['Authorization'] = `Bearer ${window.localStorage.getItem(
          'token',
        )}`;
      }
      if (window.localStorage.getItem('openId')) {
        config.headers['openId'] = window.localStorage.getItem('openId');
      }
      // config.headers['Senke-Origin'] = 'pc';
      // if ('Authorization' in config.headers) {
      //   delete config.headers['Authorization'];
      // }
      if (config.url.indexOf('/Login') > -1) {
        if ('Authorization' in config.headers) {
          console.log(config.headers);
          delete config.headers['Authorization'];
        }
      }
      //   // config.headers['Authorization'] = '';
      //   console.log('in header config');
      //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      // }

      // let timeStamp = Date.now();
      // if (config.url.indexOf('?') > -1) {
      //   config.url += `&n=${timeStamp}`;
      // } else {
      //   config.url += `?n=${timeStamp}`;
      // }
      // console.log(config, 'config');
      return config;
    },
  ],
  responseInterceptors: [
    (response: any) => {
      const { data } = response;
      console.log(data, 'data');
      if (NoLoginCode.includes(data?.code)) {
        // login()
        handleTokenExpired()
        
      } else if (data?.code !== 200) {
        if (data?.msg) {
          Toast.fail(data?.msg);
        }
      }
      return response;
    },
  ],
};

function handleTokenExpired() {
  // 清除本地存储的token
  window.localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('loginInfo');
  history.push('/login');
}
